/* eslint-disable sort-keys */
import { darken, lighten } from "polished"

export const colors = {
  black: "#1A1A1A",
  borderDark: "#70707040",
  danger: "#E74C3C",
  dangerDark: darken(0.1, "#E74C3C"),

  green: "#43a445",

  grey200: "#ECF2F4",
  grey300: "#D0D0D0",
  grey400: "#575757",
  grey500: "#818181",
  grey700: "#959595",

  primary: "#ff2f89",
  primaryDark: "#66002c",
  primaryLight: lighten(0.25, "#236fff"),
  primaryMedium: lighten(0.1, "#236fff"),

  secondary: "#fff",

  success: "#25A52A",
  warning: "#FB8C00",

  white: "#fff",
}
